export const reportInventoryPercentagesTypes = {
  SET_INVENTORY_PERCENTAGES_FILTERS: 'REPORT_INVENTORY_PERCENTAGES/SET_FILTERS',
  RESTORE_INITIAL: 'REPORT_INVENTORY_PERCENTAGES/RESTORE_INITIAL'
};
